import React, { useEffect, useState, useMemo } from 'react';
import * as actions from "../actions";
import { connect, useSelector } from 'react-redux';
// eslint-disable-next-line no-unused-vars
import * as _ from 'lodash';
import {
	Button,
	Col,
	Container,
	Icon,
	ProgressBar,
	Row,
	Table,
	TextInput,
	Pagination,
} from "react-materialize";
import TopHeader from './TopHeader';
import { CUSTOMER } from '../api/Constants';
import CustomDropdown from './common/CustomDropdown/DropDown';
import CustomDatePicker from './common/DatePicker';
import { Input } from 'antd';
import {
	DIGITALOCEAN_PUBLIC_URL,
	buildTimestampedUploadFileName,
	listDigitalOceanSpacesObjects,
	uploadToDigitalOceanSpaces,
} from "../api/Util";

export default connect(mapStateToProps, actions)(() => {

	const websiteUsers = useSelector(state => state.allWebsiteUsers.website_users);
	const [selectedFile, setSelectedFile] = useState(null);
	const [viewAs, setViewAs] = useState("");
	const [link, setLink] = useState([]);
	const [videoList, setVideoList] = useState("");
	const [progressBar, setProgressBar] = useState([]);
    const [options, setOptions] = useState([]);
	const [isLoading, setIsLoading] = useState(false);

	const [toolTipText, setToolTipText] = useState("Copy to Clipboard");

	// Pagination and Filter States
	const [currentPage, setCurrentPage] = useState(1);
	const [searchTerm, setSearchTerm] = useState("");
	const [startDate, setStartDate] = useState(null);
	const [endDate, setEndDate] = useState(null);
	const itemsPerPage = 10;

	useEffect(() => {
		var option;
		option = (websiteUsers || [])?.filter((user)=> user.client_type === CUSTOMER && !user?.is_deleted).map(user => {
			return {
				value:`${user.client_id}` , 
				label: `${user.fullname} (${user.client_type})`
			}
		})
		setOptions(option);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [websiteUsers]);

	const handleFileInput = (e) => {
		setSelectedFile(e.target.files);
	}

	let progressInfos = [];

	const handleClick = (selectedFile) => {
		for (let i = 0; i < selectedFile.length; i++) {
			progressInfos.push({ percentage: 0, fileName: selectedFile[i].name });
			uploadFile(i, selectedFile[i]);
		}
	};

	const uploadFile = (i, file) => {
		setIsLoading(true);
		const uploadFileName = buildTimestampedUploadFileName(file);
		const key = `${viewAs}/${uploadFileName}`;

		uploadToDigitalOceanSpaces({
			file,
			key,
			onComplete: (err, data) => {
				if (err) {
					setIsLoading(false);
					if (err.code === 'RequestAbortedError') {
						console.log("upload aborted");
					} else {
						console.log("upload failed");
					}
					return err;
				}
				setIsLoading(false);
				const temp = data?.Key ? `${DIGITALOCEAN_PUBLIC_URL}/${data.Key}` : null;
				setLink(link => [...link, temp]);
			},
			onProgress: (percentage) => {
				const tempProgress = [...progressInfos];
				tempProgress[i].percentage = percentage;
				setProgressBar(tempProgress);
			},
		});

	}

	function listFile() {
		setIsLoading(true);
		listDigitalOceanSpacesObjects({ prefix: `${viewAs}/`, delimiter: "/" })
			.then((data) => {
				setIsLoading(false);
				setVideoList(data?.Contents || []);
			})
			.catch((err) => {
				setIsLoading(false);
				console.log(err);
			});
	}

    const handleCustomerTypeChange = (value) => {
            setViewAs(value);
      };

	// Filter and pagination logic
	const filteredVideoList = useMemo(() => {
		if (!videoList || videoList.length === 0) return [];

		let filtered = videoList.filter(video => {
			// Search filter
			const matchesSearch = searchTerm === "" || 
				video.Key.toLowerCase().includes(searchTerm.toLowerCase());

			// Date range filter
			let matchesDateRange = true;
			if (startDate || endDate) {
				const videoDate = new Date(video.LastModified);
				const start = startDate ? new Date(startDate) : null;
				const end = endDate ? new Date(endDate) : null;

				if (start && videoDate < start) matchesDateRange = false;
				if (end && videoDate > end) matchesDateRange = false;
			}

			return matchesSearch && matchesDateRange;
		});

		return filtered.sort((a, b) => new Date(b.LastModified) - new Date(a.LastModified));
	}, [videoList, searchTerm, startDate, endDate]);

	// Pagination logic
	const totalPages = Math.ceil(filteredVideoList.length / itemsPerPage);
	const startIndex = (currentPage - 1) * itemsPerPage;
	const endIndex = startIndex + itemsPerPage;
	const currentVideos = filteredVideoList.slice(startIndex, endIndex);

	// Reset to first page when filters change
	useEffect(() => {
		setCurrentPage(1);
	}, [searchTerm, startDate, endDate]);

	const handlePageChange = (page) => {
		setCurrentPage(page);
	};

	const clearFilters = () => {
		setSearchTerm("");
		setStartDate(null);
		setEndDate(null);
		setCurrentPage(1);
	};

	return <Container id="video_upload">
		{isLoading ? <Row><ProgressBar /></Row> : ""}
		<div className="aside-right-top-bar">
			<div className="top-bar-left">
				<div className="top_bar">
					<h3>Upload Video</h3>
				</div>
			</div>
			<div className="top-bar-right">
				<TopHeader />
			</div>
		</div>
		<div className="upload-main">
			<div className="select-customer-profile">
				<Row>
					<Col s={12} m={3}>
						<CustomDropdown
						options={options}
						placeholder="Select Customer Profile"
						className="z-depth-1 select-view-as upload-customer-files"
						dropdownValue={viewAs}
						handleOnchange={handleCustomerTypeChange}
						/>
					</Col>
				</Row>
			</div>
			{
				progressBar && progressBar?.map((item, i) => {
					return <div className="row">
						<Col s={12} className="label-column11" >
							<label><strong className="blue-text">{`File Upload Progress for ${item.fileName}: `}</strong>{item.percentage}%</label>
						</Col>
					</div>
				})
			}
			<div className="select-video">
				<TextInput type="file" multiple onChange={handleFileInput} disabled={!viewAs} label="Select Video " />
			</div>
			<div className="upload-warning-message">
				<div className="upload-warning-icon-wrapper">
					<span className="upload-warning-icon">!</span>
				</div>
				<span className="upload-warning-text">
					Filenames should not include special characters (e.g., #, $, %, &). Please follow our file naming convention YYYY.MM.DD_ClientName_ProjectName.
				</span>
			</div>
			<div className="upload-video-btns">
				<Button className="uploadbtn submit_btn" onClick={() => handleClick(selectedFile)} disabled={(!viewAs) || !selectedFile}> Upload Video</Button>
				<Button className="uploadbtn submit_btn" onClick={listFile} disabled={!viewAs}> List of videos</Button>
			</div>
			
			{/* Search and Filter Section */}
			{videoList && videoList.length > 0 && (
				<div className="filter-section">
					<Row>
						<Col s={12}>
							<h5>Search & Filter Videos</h5>
						</Col>
					</Row>
					<Row className="filter-row">
						<Col s={12} m={4} l={3}>
							<div className="filter-input-wrapper">
								<Input
									placeholder="Search videos..."
									allowClear
									value={searchTerm}
									onChange={(e) => setSearchTerm(e.target.value)}
									prefix={<Icon className="filter-search-icon">search</Icon>}
								/>
							</div>
						</Col>
						<Col s={12} m={4} l={3}>
							<div className="filter-date-wrapper">
								<CustomDatePicker
									className="upload-video-date-picker"
									setStartDate={setStartDate}
									setEndDate={setEndDate}
									startDate={startDate}
									endDate={endDate}
								/>
							</div>
						</Col>
						<Col s={12} m={4} l={2}>
							<div className="filter-button-wrapper">
								<Button 
									className="red lighten-1 standard-btn filter-clear-btn" 
									onClick={clearFilters}
									icon={<Icon>clear</Icon>}
								>
									Clear
								</Button>
							</div>
						</Col>
						<Col s={12} m={12} l={4}>
							<div className="filter-count-wrapper">
								<p className="filter-count-text">
									Showing {currentVideos.length} of {filteredVideoList.length} videos
									{filteredVideoList.length !== videoList.length && ` (filtered from ${videoList.length} total)`}
								</p>
							</div>
						</Col>
					</Row>
				</div>
			)}
		</div>
		<Row>
			{
				link && link?.map((item, i) => {
					return <Col s={12} className="label-column11 after_upload" >
						<label> <strong className="blue-text uploaded-video-link">{`Uploaded Video Link ${i + 1} : `}</strong> {item}</label>
						<Button icon={<Icon>content_copy</Icon>} className="text-copy-btn" tooltip={toolTipText} onClick={() => { navigator.clipboard.writeText(item); setToolTipText("Copied") }} />
					</Col>
				})
			}
		</Row>
		{/* Video List Table with Pagination */}
		{
			videoList && videoList.length > 0 && (
				<>
					{filteredVideoList.length > 0 ? (
						<>
							<div className="upload-video-table-wrapper">
								<Table className="highlight responsive-table">
									<thead>
										<tr>
											<th>Serial Number</th>
											<th>Video</th>
											<th>Last Modified</th>
											<th>Link</th>
											<th>Copy</th>
										</tr>
									</thead>
									<tbody>
										{
											currentVideos.map((videos, i) => {
												let p = videos.Key.search("/");
												const globalIndex = startIndex + i + 1;
												return (
													<tr key={"table-key-" + i}>
														<td>{globalIndex}</td>
														<td className="video-name-cell">{videos.Key.slice(p + 1)}</td>
														<td className="video-date-cell">{new Date(videos.LastModified).toLocaleString()}</td>
														<td className="video-link-cell">
															<span title={`${DIGITALOCEAN_PUBLIC_URL}/${videos.Key}`}>
																{`${DIGITALOCEAN_PUBLIC_URL}/${videos.Key}`.length > 50 
																	? `${DIGITALOCEAN_PUBLIC_URL}/${videos.Key}`.substring(0, 50) + "..."
																	: `${DIGITALOCEAN_PUBLIC_URL}/${videos.Key}`
																}
															</span>
														</td>
														<td>
															<Button 
																icon={<Icon>content_copy</Icon>} 
																className="text-copy-btn"
																tooltip="Copy to clipboard"
																onClick={() => {
																	navigator.clipboard.writeText(`${DIGITALOCEAN_PUBLIC_URL}/${videos.Key}`);
																}}
															/>
														</td>
													</tr>
												)
											})
										}
									</tbody>
								</Table>
							</div>
							
							{/* Pagination */}
							{totalPages > 1 && (
								<Row>
									<Col s={12} className="center-align pagination-wrapper">
										<Pagination
											items={totalPages}
											activePage={currentPage}
											onSelect={handlePageChange}
											maxButtons={5}
										/>
										<p className="pagination-info">
											Page {currentPage} of {totalPages}
										</p>
									</Col>
								</Row>
							)}
						</>
					) : (
						<Col s={12} className="center-align no-videos-message">
							<Icon large>search_off</Icon>
							<h5>No videos found matching your criteria</h5>
							<p>Try adjusting your search terms or date range</p>
							<Button onClick={clearFilters} className="blue lighten-1">
								Clear Filters
							</Button>
						</Col>
					)}
				</>
			)
		}
		{/* No videos message */}
		{
			videoList && videoList.length === 0 &&
			<Col s={12} className="center-align no-videos-message">
				<Icon large>video_library</Icon>
				<h5>No Uploaded Videos Found</h5>
				<p>Upload some videos to see them listed here</p>
			</Col>
		}
	</Container>
});

function mapStateToProps({ cards, auth, users, settings }) {
	return { cards, auth, users, settings };
};